export enum ACTION {
  UPDATE_FILTERS = 'UPDATE_FILTERS',
  UPDATE_DATA = 'UPDATE_DATA',
  UPDATE_CAN_ACCESS_TOF_PREMIUM = 'UPDATE_CAN_ACCESS_TOF_PREMIUM',
}

export enum COLORS {
  BRAND = '#006AFF',
  YELLOW400 = '#F2A619',
  YELLOW600 = '#8A5700',
  BLUE500 = '#0D4599',
  LIGHTBLUE = '#E0F2FF',
  GRAY200 = '#F1F1F4',
  GRAY300 = '#D1D1D5',
  GRAY400 = '#A6B3C4',
  TEXT_MEDIUM = '#596B82',
}

export interface IFilters {
  filterType: string;
  beds: string | undefined;
  propertyType: string | undefined;
}

export interface UpdatePremiumFiltersAction {
  type: ACTION.UPDATE_FILTERS;
  payload: { filters: Partial<IFilters> };
}

export interface UpdateDataAction {
  type: ACTION.UPDATE_DATA;
  payload: { data: Partial<IFreemiumState> };
}

export interface UpdateCanAccessTofPremiumAction {
  type: ACTION.UPDATE_CAN_ACCESS_TOF_PREMIUM;
  payload: { canAccessTopOfFunnelPremium: boolean };
}

export type FreemiumAction = UpdatePremiumFiltersAction | UpdateDataAction | UpdateCanAccessTofPremiumAction;

export interface InquiryPayload {
  count?: number;
  isProperty?: boolean;
  isMarketMedian?: boolean;
  price?: string;
  labelListDataKey?: string;
}

export type MarketListingsPayload = {
  timestamp: string;
  compsCount: number;
  cityCount: number;
};

export type FilterCriteria = {
  filterType: string;
  propertyType: number | null | string;
  beds: number | null | string;
};

export type FreemiumProduct = {
  price: string;
  type: number;
  duration: string;
  description: { benefits: Array<unknown>; title: string; subtitle: string };
};

export type IFreemiumState = {
  featuresOfPremiumRef?: React.RefObject<HTMLDivElement> | null;
  isListingActive: boolean;
  filters: IFilters;
  canAccessTopOfFunnelPremium: boolean;
};
